export default {
  unitLabel: {
    carbonNitrogen: 'Kohlenstoff / Stickstoff',
    thickness: 'Dicke',
  },
};
